import React from 'react';
import styled from '@emotion/styled';

import { ReactModal } from 'ui_system/modals/ReactModal';
import { Theme } from 'ui_system/theme';

const Main = styled.div`
  text-align: center;
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
`;

const Message = styled.p`
  font-size: 16px;
`;

const ConfirmButton = styled.button`
  font-size: 16px;
  padding: 10px 18px;
  margin-top: 40px;
  border-radius: 4px;
  color: ${(props) => (props.theme ? props.theme.buttonTextColor : 'white')};
  background: ${(props) =>
    props.theme
      ? props.theme.buttonBackgroundColor
      : Theme.colors.linksDesignElementsBaseColor};
  height: 44px;
`;
// ===== Modal Action Buttons

const SessionTimeout = ({ onClose }) => {
  return (
    <Main>
      <Title>Session Expired</Title>
      <Message>
        You have been logged out after 2 hours of inactivity.
        <br />
        <br />
        Please log in again.
      </Message>
      <ConfirmButton onClick={onClose}>Okay</ConfirmButton>
    </Main>
  );
};

export const SessionTimeoutModal = styled(
  ReactModal(SessionTimeout, { isCloseButtonHidden: true })
)`
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    width: 540px;
  }
`;
